<template>
	<div class="dots-group">
		<span class="accent-2" :class="color"></span>
		<span class="accent-2" :class="color"></span>
		<span class="accent-2" :class="color"></span>
		<span class="accent-2" :class="color"></span>
		<span class="accent-2" :class="color"></span>
	</div>
</template>

<script>
export default {
	props: ['color'],
}
</script>
<style scoped lang="scss">
	.dots-group {
		flex-grow: 1;
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		justify-items: center;
		
		span {
			display: inline-block;
			width: 15px;
			height: 15px;
			border-radius: 8px;
			box-shadow: inset 0px 5px 5px 0px rgba(0,0,0,0.2);
		}
	}
</style>